var Aneox;
(function (Aneox) {
  (function (Sequences) {
    'use strict';

    var Wines = (function () {

      var self;
      var animations;
      var timeline;

      var hasPlayedThroughAnimation = {};

      function Wines(anims) {
        self = this;
        animations = anims;
        timeline = new TimelineMax({ paused: true });

        timeline
        .add(animations.OpeningTimeline($('#wines-opening')))
        .addPause()
        .addLabel('text')
        .from('#wines-line', 1, { scaleX: 0 })
        .add(animations.TextTimeline($('#wines-text')), 'text')
        .addPause()
        .addLabel('list')
        .add(animations.BorderBoxTimeline($('#wines-list'), true))
        .add(animations.SubtitleTimeline($('#wines-white-title')), 'list+=.5')
        .staggerFrom('#wines-white .wine-li', .5, { opacity: 0 }, .1, '-=.5')
        .add(animations.SubtitleTimeline($('#wines-red-title')))
        .staggerFrom('#wines-red .wine-li', .5, { opacity: 0 }, .1, '-=.5')
        .addPause()
        .addLabel('closing')
        .add(animations.TextTimeline($('#wines-closing-quotation')))
        .add(animations.ImgTimeline($('#wines-img6-wrapper')));
      }

      Wines.prototype.mastEnterAnimation = function() {
        timeline.play();
      };

      Wines.prototype.textEnterAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('text')) return;
        timeline.seek('text').play();
      };

      Wines.prototype.listEnterAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('list')) return;
        timeline.seek('list').play();
      };

      Wines.prototype.closingAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('closing')) return;
        timeline.seek('closing').play();
      };

      Wines.prototype.fastForwardAnimations = function() {
        timeline.pause().progress(1);
      };

      Wines.prototype.resetAnimations = function() {
        timeline.pause().progress(0);
      }

      Wines.prototype.handleWindowResize = function(bodyWidth, bodyHeight) {

      };


      return Wines;
    })();

    Sequences.Wines = Wines;
  })(Aneox.Sequences || (Aneox.Sequences = {}));
})(Aneox || (Aneox = {}));